import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type { IdParam, JsonOrFormBody, JsonRecord } from './types/api-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesCatalogService {
  constructor(private _cS: CommonService) {}

  addProgram(programBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddProgram, programBody);
  }
  updateProgram(programBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateProgram, programBody);
  }
  deleteProgram(programId: IdParam) {
    return this._cS.API_DELETE(EndPoints.DeleteProgram + `/${programId}`);
  }
  getAllPrograms(requestBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.GetAllPrograms, requestBody, false);
  }

  makeProgramDefault(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.makeProgramDefault, formData, false, {
      headers: hd,
    });
  }
  updateProgramVisible(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateProgramVisible, formData, false, {
      headers: hd,
    });
  }

  getAllPPartners(requestBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.getAllPPartners, requestBody, false);
  }
  addPPartners(PPartnerBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddPPartner, PPartnerBody);
  }
  deletePPartner(partnerId: IdParam) {
    return this._cS.API_DELETE(EndPoints.DeletePPartner + `/${partnerId}`);
  }
  AddPartnerFromDB(formdata: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.AddPartnerFromDB, formdata, false, {
      headers: hd,
    });
  }
  searchInDatabasePartner(searchText: string, siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetDBPartner + `?searchText=${searchText}&siteId=${siteId}`,
      false
    );
  }

  addVendors(formdata: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.AddVendors, formdata, false, {
      headers: hd,
    });
  }
  deletePVendors(vendorId: IdParam) {
    return this._cS.API_DELETE(EndPoints.DeletePVendors + `/${vendorId}`);
  }
  AddVendorFromDB(formdata: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.AddVendorFromDB, formdata, false, {
      headers: hd,
    });
  }

  searchInDatabase(searchText: string, siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetDBVendors + `?searchText=${searchText}&siteId=${siteId}`,
      false
    );
  }

  getAllTags(requestBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.GetAllTags, requestBody, false);
  }

  addTagGroup(tagGroupData: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddTagGroup, tagGroupData, false);
  }
  updateTagGroup(tagGroupData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateTagGroup, tagGroupData, false);
  }
  deleteTagGroup(groupId: IdParam) {
    return this._cS.API_DELETE(EndPoints.DeleteTagGroup + `/${groupId}`);
  }
  addTag(tagData: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddTag, tagData, false);
  }
  updateTag(tagData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateTag, tagData, false);
  }
  deleteTag(groupId: IdParam, tagId: IdParam) {
    return this._cS.API_DELETE(EndPoints.DeleteTag + `/${groupId}/${tagId}`);
  }

  GetSiteNonAlcBalance(siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetSiteNonAlcBalance + `?siteId=${siteId}`,
      false
    );
  }
}
